import { Button, IconArrowLineDown, Tooltip } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Item } from 'typings'
import { exportToCsv } from '../../../utils/export'
import messages from './messages'

interface Props {
  values: Item[]
}

export function DownloadButton(props: Props) {
  const { values } = props

  const { $t } = useIntl()

  const handleClick = (event: React.MouseEvent) => {
    exportToCsv(values.map((item) => item.id))
    event.stopPropagation()
  }
  return (
    <Tooltip text={$t(messages.download)}>
      <Button
        variant="neutralTertiary"
        icon={<IconArrowLineDown />}
        aria-label={$t(messages.download)}
        hidden={!values.length}
        onClick={handleClick}
      />
    </Tooltip>
  )
}
